import { EMAIL_REGEX } from "./validation/email-regex";

export function isEmailValid(email?: string): boolean {
  if (!email) return false;
  return EMAIL_REGEX.test(email);
}
